import { useMemo } from 'react'
import settings from '../../../api/settings/hooks'
import { PropertyTranslations } from '../../../api/properties/types/response'
import { APPLICATION_SETTINGS } from '../../../common/constants'
import { realEstateDescriptionInputs } from '../../../common/forms/generalRealEstate/inputs'
import { realEstateDescriptionValidation } from '../../../common/forms/generalRealEstate/validations'

export const usePropertyDescriptionFormConfig = (translations?: PropertyTranslations) => {
    const { data: availableTranslationLanguages = [] } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.availableTranslationLanguages,
    })

    const appSettings = useMemo(
        () => ({
            currency: APPLICATION_SETTINGS.CURRENCY,
            languages: availableTranslationLanguages.map((lang) => lang.abbreviation),
        }),
        [availableTranslationLanguages]
    )

    const descriptionInputs = realEstateDescriptionInputs(appSettings)
    const descriptionValidationConfig = realEstateDescriptionValidation(translations, appSettings.languages)

    return {
        descriptionInputs,
        descriptionValidationConfig,
    }
}
